import * as types from "./types";

export const fetchAllFavorites = vbids => {
  return async dispatch => {
    if (vbids.length === 0) {
      dispatch({
        type: types.FETCH_ALL_FAVORITES_FAILURE,
        error: "No VBIDs provided"
      });
      return;
    }

    dispatch({ type: types.FETCH_ALL_FAVORITES_REQUEST });

    try {
      const queryString = vbids.map(vbid => `vbids[]=${vbid}`).join("&");
      const response = await fetch(
        `/decimal/api/v1/users/favorites/for?${queryString}`,
        {
          method: "GET",
          credentials: "include"
        }
      );

      if (!response.ok) {
        throw new Error("Failed to fetch favorites");
      }

      const data = await response.json();
      dispatch({ type: types.FETCH_ALL_FAVORITES_SUCCESS, payload: data });
    } catch (error) {
      dispatch({
        type: types.FETCH_ALL_FAVORITES_FAILURE,
        error: error.message || "Unknown error"
      });
    }
  };
};

export const addFavorite = vbid => {
  return async dispatch => {
    dispatch({ type: types.ADD_FAVORITES_REQUEST });
    try {
      const response = await fetch(`/decimal/api/v1/users/favorites`, {
        method: "POST",
        credentials: "include",
        headers: {
          "Content-Type": "application/json; charset=UTF-8"
        },
        cors: {
          origin: true,
          method: ["POST"],
          allowedHeaders: ["Content-Type", "Authorization", "X-Requested-With"],
          credentials: true
        },
        body: JSON.stringify({ vbid })
      });

      if (!response.ok) {
        throw new Error("Failed to add favorite");
      }

      dispatch({ type: types.ADD_FAVORITES_SUCCESS, payload: vbid });
    } catch (error) {
      dispatch({
        type: types.ADD_FAVORITES_FAILURE,
        error: error.message || "Unknown error"
      });
    }
  };
};

export const deleteFavorite = vbid => {
  return async dispatch => {
    dispatch({ type: types.DELETE_FAVORITES_REQUEST });

    try {
      const response = await fetch(`/decimal/api/v1/users/favorites/${vbid}`, {
        method: "DELETE",
        credentials: "include",
        cors: {
          origin: true,
          method: ["DELETE"],
          allowedHeaders: ["Content-Type", "Authorization", "X-Requested-With"],
          credentials: true
        }
      });

      if (!response.ok) {
        throw new Error("Failed to delete favorite");
      }

      dispatch({ type: types.DELETE_FAVORITES_SUCCESS, payload: vbid });
    } catch (error) {
      dispatch({
        type: types.DELETE_FAVORITES_FAILURE,
        error: error.message || "Unknown error"
      });
    }
  };
};
